import { render, staticRenderFns } from "./FavoriteButtons.vue?vue&type=template&id=44a47302&scoped=true&"
import script from "./FavoriteButtons.vue?vue&type=script&lang=js&"
export * from "./FavoriteButtons.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteButtons.vue?vue&type=style&index=0&id=44a47302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a47302",
  null
  
)

export default component.exports